import { useMemo } from "react";
import { useSelectorApp } from "../lib/redux";
import {
  buildCreditCostsDerived,
  DEFAULT_AD_SPEND_FEE_PERCENTAGE,
} from "../utils/creditActionCosts";

/**
 * Credit costs for ads actions, merged from defaults and optional agency RTDB overrides.
 * Re-renders when `payments.creditActionCosts` or `payments.creditPricingVersion` updates (after load).
 */
export const useCreditActionCosts = () => {
  const snapshot = useSelectorApp((state) => state.payments?.creditActionCosts);
  const creditPricingVersion = useSelectorApp(
    (state) => state.payments?.creditPricingVersion
  );
  const adSpendFeePercentage = useSelectorApp(
    (state) =>
      state.payments?.adSpendFeePercentage ?? DEFAULT_AD_SPEND_FEE_PERCENTAGE
  );

  return useMemo(
    () => ({
      ...buildCreditCostsDerived(
        snapshot,
        creditPricingVersion,
        adSpendFeePercentage
      ),
      creditPricingVersion,
    }),
    [snapshot, creditPricingVersion, adSpendFeePercentage]
  );
};
